import styled from "styled-components";

export const QueryContainer = styled.div`
  flex-grow: 1;
`;
